import * as React from 'react';
import { BrowserRouter, Switch, Route } from 'react-router-dom';
import { Button, Provider, ThemePrepared, Loader, Flex, Image, Divider, Avatar, Text, DoorArrowLeftIcon } from '@fluentui/react-northstar';
import TeamsThemeHelper from './helpers/TeamsThemeHelper'
import AuthHelper from './helpers/Auth-Helper'
import { app, authentication, HostClientType} from '@microsoft/teams-js';
import SignIn from './components/SignIn';
import Styles from './styles/Styles';
import SearchCase from './components/SearchIndex';
import { CaseType } from './helpers/constants';
import CreateChannelComponent from './components/CreateChannel';
import axios from 'axios';
import SettingsComponent from './components/Settings';
import ChannelTabComponent from './components/ChannelTab';
import ConfigurationComponent from './components/Configuration';
import PrivacyComponent from './components/PrivacyPolicy';
import TermsComponent from './components/TermsConditions';
import LoginComponent from './components/Login';
import LoginSSOComponent from './components/LoginSSO';
import SSORedirectComponent from './components/SSORedirect';
import HomeComponent, { BaseComponent } from './components/Home';
import { HttpRequest, RequestHeaders } from './helpers/HttpRequest';
import { References } from './helpers/References';
import { Helpers } from './helpers/Helpers';
import RedirectSucess from './components/RedirectSuccess';

var userIdentifier;
var caseId = '';
class App extends React.Component<IAppProps, IAppState> {
    constructor(props) {
        super(props);
        this.handleLogOut = this.handleLogOut.bind(this);
        this.state = {
            theme: TeamsThemeHelper.getTheme('default'),
            themeString: 'default',
            loggedIn: true,
            isLoading: true,
            redirectedPage: "",
            from: "",
            isLoadingChildPage: true,
            userInfo: { name: '', image: require('./Images/avatar.svg'), status: 'Offline', color: 'grey' },
            isLoggingOut: false,
            isGranted: true,
            validAccount: true,
            isMobile: false,
            isLicensed: true
        };
        this.notifySuccess = this.notifySuccess.bind(this);
        app.initialize()
            .then(() => {
                
                app.registerOnThemeChangeHandler(this.updateTheme.bind(this));
                app.getContext()
                    .then(async context => {                        
                        caseId = context.page.subPageId;
                        userIdentifier = context.user.id + '.' + context.user.tenant.id;
                        
                        if(context.app.host.clientType === HostClientType.android || context.app.host.clientType === HostClientType.ios){
                            this.setState({isMobile: true})
                        }
                        this.updateTheme(context.app.theme);                                                
                        await this.checkUserIfLoggedIn();                        
                        this.redirectToPage(context);
                    });
            })  
            .catch(error => {
                this.redirectToPage();
            })      
    }
    componentDidMount() {
        window.addEventListener('resize', this.resize.bind(this));
        window.addEventListener('logging', this.logging.bind(this));
        var urlArray = window.location.href.split('/');
        var relativeUrl = urlArray[urlArray.length - 1];
        if (relativeUrl.includes('?'))
            relativeUrl = relativeUrl.split('?')[0];
        if (relativeUrl != 'signin') {
            window.sessionStorage.setItem('redirection', relativeUrl);
            this.setState({ redirectedPage: relativeUrl });
        }
    }
    logging(e) {
        if (e != null && e.detail != null) {
            var from = e.detail;
            from = from.replace('create', '');
            window.location.href = from;
        }
        else
            window.location.reload();
    }
    resize() {
        let currentIsMobile = window.innerWidth <= 760;
        if (currentIsMobile !== this.state.isMobile)
            this.setState({ isMobile: currentIsMobile });
    }
    
    componentWillUnmount() {
        window.removeEventListener("resize", this.resize.bind(this));
        window.removeEventListener("logging", this.logging.bind(this));
    }
    handleErrorAPI(code) {

    }
    checkTeamsMembers() {
        var url = "/setup/CheckTeamsMembers";
        axios.get(url)
            .then(response => {
                var resp = response.data;
            })
            .catch(error => {
                console.log(error);
            });
    }
    checkIfGrantPermissions() {
        var url = "/home/CheckIfPermissionsGranted";
        axios.get(url)
            .then(response => {
                var resp = response.data;
                this.setState({ isGranted: resp == "Granted" });
            })
            .catch(error => {
                console.log(error);
                this.setState({ isGranted: false });
            });
    }
    notifySuccess(response) {
        if (this.state.isMobile) {
            var data = response;
            var apiKey = data.apiKey ?? data.success.data.token;
            var baseUrl = data.url ?? data.instanceUrl;
            var installationType = data.installationType ?? "on-cloud";

            let formData = new FormData();
            formData.append('res[data][url]', baseUrl);
            formData.append('res[data][key]', apiKey);
            formData.append('res[data][installationType]', installationType);

            //Save in browser storage and backend session
            if (baseUrl != null && apiKey != null) {

                axios.post('/account/SaveCredentials', formData)
                    .then(response => {
                        //Save to local storage                                                                
                        Helpers.saveToLocalStorage('url', baseUrl);
                        Helpers.saveToLocalStorage('apiKey', apiKey);
                        Helpers.saveToLocalStorage('installationType', installationType);                                                

                        window.location.href = '/base';                                                    
                    })
                    .catch(error => {
                        window.location.reload();
                    })
            }
        }
        else {
            authentication.notifySuccess(response);
        }
    }
    handleLogOut() {
        var url = "/setup/Logout";
        this.setState({ isLoggingOut: true });
        localStorage.clear();
        axios.get(url)
            .then(response => {
                var urlArray = window.location.href.split('/');
                var relativeUrl = urlArray[urlArray.length - 1];
                if (relativeUrl.includes('?'))
                    relativeUrl = relativeUrl.split('?')[0];
                if (relativeUrl != 'signin') {
                    window.sessionStorage.setItem('redirection', relativeUrl);
                }                
                try {
                    localStorage.clear();                    
                }
                catch (err) {
                    console.log(err);
                }
                this.setState({ redirectedPage: 'signin' });
                const event = document.createEvent('Event');
                event.initEvent('logging');
                window.dispatchEvent(event);
            })
            .catch(error => {
                console.log(error);
                var urlArray = window.location.href.split('/');
                var relativeUrl = urlArray[urlArray.length - 1];
                if (relativeUrl.includes('?'))
                    relativeUrl = relativeUrl.split('?')[0];
                if (relativeUrl != 'signin') {
                    window.sessionStorage.setItem('redirection', relativeUrl);
                }
                try {
                    localStorage.clear();
                }
                catch (err) {
                    console.log(err);
                }
                this.setState({ redirectedPage: 'signin' });
                const event = document.createEvent('Event');
                event.initEvent('logging');
                window.dispatchEvent(event);
                //window.location.href = '/signin';
            });
    }
    async getUserInformation() {
        var storedUserName = sessionStorage?.getItem('user-name');
        var storedPicture = sessionStorage?.getItem('profile-picture');
        this.setState({ userInfo: { name: storedUserName, image: storedPicture != null ? storedPicture : require('./Images/avatar.svg'), status: 'Available', color: 'green' } });
        
        
        var dataToPost = 'lang=english';        
        HttpRequest.get(References.userCheckApi).then(async response => {            
            var data = response.data?.success?.data;
            if (data) {
                //Save credentials to back-end
                let credentials = new RequestHeaders();                
                let formData = new FormData();
                formData.append('res[data][url]', credentials?.url);
                formData.append('res[data][key]', credentials?.apiKey);
                formData.append('res[data][installationType]', localStorage?.getItem("installationType"));
                axios.post('/account/SaveCredentials', formData);                   

                var userName = data.profileName;
                if (userName !== storedUserName) {
                    localStorage.setItem('user-name', userName);
                    this.setState({ userInfo: { ...this.state.userInfo, name: userName } });
                }
                if(!storedPicture){                
                var resp = await HttpRequest.post(References.userCheckInfoApi, dataToPost);
                    if (resp) {
                        try {
                            var userData = resp.data.success.data;
                            var userId = userData.userId;
                            var profilePicture = userData.profilePicture;
                            var pictureType = profilePicture.type;
                            var pictureContent = profilePicture.content;
                            const dataAsUrl = 'data:image/' + pictureType + ';base64,' + pictureContent;
                            sessionStorage.setItem('profile-picture', dataAsUrl);
                            sessionStorage.setItem('userId', userId);
                            this.setState({ userInfo: { ...this.state.userInfo, image: dataAsUrl != null ? dataAsUrl : require('./Images/avatar.svg'), status: 'Available', color: 'green' } });
                        }
                        catch (err) {

                        }
                    }
                }
            }
        }).catch(error => {

        });
    }
    redirectToPage(context: app.Context = null) {
        if(!context){
            this.setState({ loggedIn: true, isLoading: false, isLicensed: true })
        }
        var mail = context?.user.userPrincipalName?.toLocaleLowerCase();
        let url = "/home/GetLoggedInMail";
        var self = this;
        axios.get(url)
            .then(response => {
                if (response != null) {
                    var loggedMail = response.data.toLowerCase();
                    if (loggedMail.length > 0 && mail.length > 0) {
                        var redirection = window.sessionStorage.getItem('redirection');
                        if (loggedMail.localeCompare(mail) != 0 && redirection != 'login' && !redirection.includes('ssoredirect')) {
                            let url = window.location.origin + "/account/MsUserChanged";
                            let config = {
                                headers: {
                                    'Content-Type': 'application/x-www-form-urlencoded',
                                }
                            }
                            let params = new URLSearchParams();
                            params.append('teamsMail', mail);
                            params.append('serverMail', loggedMail);
                            axios.post(url, params, config)
                                .then(response => {
                                    self.setState({ loggedIn: false, isLoading: false, validAccount: false })
                                })
                                .catch(error => {
                                    console.log(error);
                                    self.setState({ loggedIn: false, isLoading: false, validAccount: false })
                                });
                            self.setState({ loggedIn: false, isLoading: false, validAccount: false })
                            return;
                        }
                        self.setState({
                            redirectedPage: redirection, isLoading: false, isLoadingChildPage: false
                        });
                    }
                }
            })
            .catch(function (error) {
                console.log(error);
                self.setState({ isLoading: true })
            });
        return <div />
    }
    async checkUserIfLoggedIn() {
        AuthHelper.IsUserLoggedIn(this.state.isMobile)
        .then(loginData => {
            if (loginData.isLoggedIn && loginData.isLicensed) {
                try {
                    this.getUserInformation();
                    this.checkIfGrantPermissions();
                    this.checkTeamsMembers();
                }
                catch (err) {
                    console.log(err)
                }
            }        
            this.setState({ 
                loggedIn: loginData.isLoggedIn,
                isLicensed: loginData.isLicensed, 
                isLoading: false,
                from: window.location.pathname 
            });
        })
        .catch(loginErrorData => {
            console.log(loginErrorData)
            this.setState({ 
                loggedIn: loginErrorData.isLoggedIn,
                isLicensed: loginErrorData.isLicensed, 
                isLoading: false,
                from: window.location.pathname 
            });
        })        
    }    
    executeDeepLink(link) {        
        if (link.length > 0) {
            app.getContext()
            .then(context => {
                if (context.app.host.clientType === HostClientType.ios) {
                    window.open(link);
                }
                else {
                    app.openLink(link);
                }
            })            
        }            
    }
    render() {
        let appLogo = Helpers.isRebranded() ? require('./Images/lexzur-icon.png') : require('./Images/app4legalTitle.png');
        const bodyElement = document.body;
        bodyElement.style.backgroundColor = (this.state.themeString == 'default' ? '#F5F5F5' : (this.state.themeString == 'dark' ? '#2d2c2c' : '#000'));
        const switchPage = (redirectPage) => {
            switch (redirectPage) {
                case 'casesmeet':
                    return <SearchCase id={caseId} executeDeepLink={this.executeDeepLink} redirectPage={this.state.redirectedPage} type={CaseType.matter}  errorAPI={this.handleErrorAPI} isMobile={this.state.isMobile} />;
                case 'hearingmeet':
                    return <SearchCase id={caseId} executeDeepLink={this.executeDeepLink} redirectPage={this.state.redirectedPage} type={CaseType.hearing}  errorAPI={this.handleErrorAPI} isMobile={this.state.isMobile} />;
                case 'contractmeet':
                    return <SearchCase id={caseId} executeDeepLink={this.executeDeepLink} redirectPage={this.state.redirectedPage} type={CaseType.contract}  errorAPI={this.handleErrorAPI} isMobile={this.state.isMobile} />;
                case 'casesmeetcreate':
                    return <CreateChannelComponent executeDeepLink={this.executeDeepLink} redirectPage={this.state.redirectedPage} type={CaseType.matter}  errorAPI={this.handleErrorAPI} isMobile={this.state.isMobile} />;
                case 'hearingmeetcreate':
                    return <CreateChannelComponent executeDeepLink={this.executeDeepLink} redirectPage={this.state.redirectedPage} type={CaseType.hearing}  errorAPI={this.handleErrorAPI} isMobile={this.state.isMobile} />;
                case 'contractmeetcreate':
                    return <CreateChannelComponent executeDeepLink={this.executeDeepLink} redirectPage={this.state.redirectedPage} type={CaseType.contract}  errorAPI={this.handleErrorAPI} isMobile={this.state.isMobile} />;
                case 'settings':
                    return <SettingsComponent executeDeepLink={this.executeDeepLink} redirectPage={this.state.redirectedPage}  isMobile={this.state.isMobile} userInfo={this.state.userInfo} />;
                case 'channeltab':
                    return <ChannelTabComponent executeDeepLink={this.executeDeepLink} redirectPage={this.state.redirectedPage}  isMobile={this.state.isMobile} />;
                case 'configure':
                    return < ConfigurationComponent isMobile={this.state.isMobile}/>;
                case 'base':
                    return <BaseComponent />;

            }
        };
        const navigatePage = (redirectPage) => {
            return(<Flex column gap='gap.large' hAlign="center" vAlign="center" styles={{ backgroundColor: this.state.themeString == 'default' ? '#F5F5F5' : (this.state.themeString == 'dark' ? '#2d2c2c' : '#000') }}>
                    <Flex column styles={{ width: '80%' }} hAlign='center' vAlign='center'>                        
                        {this.state.isMobile ?
                            <Flex column styles={{ width: '100%' }} hAlign='center' vAlign='center'>
                                <Flex.Item align="center" size="size.small">
                                    <Image src={appLogo} styles={Styles.topImageStyle} />
                                </Flex.Item>
                                <Flex styles={{ width: '100%' }} hAlign='center' vAlign='center'>
                                    <div
                                        style={{
                                            display: 'flex',
                                            justifyContent: 'center',
                                            height: '32px',
                                            alignItems: 'center',
                                        }}
                                    >
                                        <Divider vertical />
                                        <Text content={this.state.userInfo.name} />
                                        <Divider vertical />
                                        <Avatar
                                            image={{ src: this.state.userInfo.image, alt: 'profile' }}
                                            status={{
                                                color: this.state.userInfo.color,
                                                title: this.state.userInfo.status,
                                            }}
                                        />
                                        <Divider vertical />
                                        <Button icon={<DoorArrowLeftIcon />} text primary content="Sign Out" onClick={this.handleLogOut} disabled={this.state.isLoggingOut} />
                                        <Divider vertical />
                                    </div>
                                </Flex>
                            </Flex>
                            :
                            <Flex inline styles={{ width: '100%' }} hAlign='center' vAlign='center'>
                                <Flex.Item align="center" size="size.small">
                                    <Image src={appLogo} styles={Styles.topImageStyle} />
                                </Flex.Item>
                                <Flex.Item push align='center'>
                                    <div
                                        style={{
                                            display: 'flex',
                                            justifyContent: 'center',
                                            height: '32px',
                                            alignItems: 'center',
                                        }}
                                    >
                                        <Divider vertical />
                                        <Text content={this.state.userInfo?.name != null ? this.state.userInfo?.name : ''} />
                                        <Divider vertical />
                                        <Avatar
                                            image={{ src: this.state.userInfo.image, alt: 'profile' }}
                                            status={{
                                                color: this.state.userInfo.color,
                                                title: this.state.userInfo.status,
                                            }}
                                        />
                                        <Divider vertical />
                                        <Button icon={<DoorArrowLeftIcon />} text primary content="Sign Out" onClick={this.handleLogOut} disabled={this.state.isLoggingOut} />
                                        <Divider vertical />
                                    </div>
                                </Flex.Item>
                            </Flex>}
                        {this.state.isGranted ? <div /> :
                            <Flex hAlign='center' vAlign='center'>
                                <Text content="Please ask your administrator to grant app permissions." color="red" />
                            </Flex>
                        }
                    </Flex>
                    <Flex vAlign='center' hAlign='center' styles={{ width: '80%' }}>
                        {this.state.isLoadingChildPage ?
                            <Loader /> :
                            (this.state.isGranted ? (switchPage(redirectPage)) : <div />)
                        }
                    </Flex>
                </Flex>)
        };
        return (
            <Provider theme={this.state.theme}>
                <div style={{ flexGrow: 1, height: '100%', backgroundColor: 'transparent' }}>
                    {this.state.isLoading ?
                    <Loader style={{backgroundColor: 'transparent', height: '100vh'}}/>
                    :
                    this.state.loggedIn && this.state.isLicensed ?
                        <BrowserRouter>
                            <Switch>
                                <Route path='/base'>
                                    {navigatePage('base')}
                                </Route>
                                <Route path='/casesmeet'>
                                    {navigatePage('casesmeet')}
                                </Route>                                
                                <Route path='/hearingmeet'>
                                    {navigatePage('hearingmeet')}
                                </Route>
                                <Route path='/contractmeet'>
                                    {navigatePage('contractmeet')}
                                </Route>
                                <Route path='/casesmeetcreate'>
                                    {navigatePage('casesmeetcreate')}
                                </Route>
                                <Route path='/hearingmeetcreate'>
                                    {navigatePage('hearingmeetcreate')}
                                </Route>
                                <Route path='/contractmeetcreate'>
                                    {navigatePage('contractmeetcreate')}
                                </Route>
                                <Route path='/settings'>
                                    {navigatePage('settings')}
                                </Route>
                                <Route path='/channeltab'>
                                    {navigatePage('channeltab')}
                                </Route>
                                <Route path='/configure'>
                                    {navigatePage('configure')}
                                </Route>
                                <Route path='/privacypolicy'>
                                    <PrivacyComponent />
                                </Route>
                                <Route path='/termsconditions'>
                                    <TermsComponent />
                                </Route>
                                <Route path='/login'>
                                    <LoginComponent notifySuccess={this.notifySuccess} theme={this.state.themeString} />
                                </Route>
                                <Route path='/sso'>
                                    <LoginSSOComponent theme={this.state.themeString} />
                                </Route>
                                <Route path='/ssoredirect'>
                                    <SSORedirectComponent notifySuccess={this.notifySuccess} />
                                </Route>
                                <Route path='/redirectSuccess'>
                                    <RedirectSucess />
                                </Route>
                                <Route path='/signin'>
                                    <SignIn validAccount={this.state.validAccount} isMobile={this.state.isMobile} theme={this.state.themeString} />
                                </Route>
                                <Route path='/' exact>
                                    <HomeComponent />
                                </Route>
                            </Switch>
                        </BrowserRouter>
                        :
                        <BrowserRouter>
                            <Switch>                                
                                <Route path='/privacypolicy'>
                                    <PrivacyComponent />
                                </Route>
                                <Route path='/termsconditions'>
                                    <TermsComponent />
                                </Route>
                                <Route path='/login'>
                                    <LoginComponent notifySuccess={this.notifySuccess} theme={this.state.themeString} />
                                </Route>
                                <Route path='/sso'>
                                    <LoginSSOComponent theme={this.state.themeString} />
                                </Route>
                                <Route path='/ssoredirect'>
                                    <SSORedirectComponent notifySuccess={this.notifySuccess} />
                                </Route>
                                <Route path='/redirectSuccess'>
                                    <RedirectSucess />
                                </Route>
                                <Route path='/'>
                                    <SignIn from={this.state.from} validAccount={this.state.validAccount} isMobile={this.state.isMobile} theme={this.state.themeString} />
                                </Route>                                
                            </Switch>
                        </BrowserRouter>
                    }
                </div>
            </Provider>
        )
    }

    private updateTheme(themeString: string | undefined): void {
        this.setState({
            theme: TeamsThemeHelper.getTheme(themeString),
            themeString: themeString
        });
    }
}

interface IAppProps {
}

interface IAppState {
    from: string,
    theme: ThemePrepared;
    themeString: string;
    loggedIn: boolean;
    isLoading: boolean;
    redirectedPage: string;
    isLoadingChildPage: boolean;
    userInfo: any;
    isLoggingOut: boolean;
    isGranted: boolean;
    validAccount: boolean;
    isMobile: boolean;
    isLicensed: boolean;
}
export default App;